/** @format */

import styled from "styled-components";
import { motion } from "framer-motion";
import { QUERIES } from "../../constants";

export const HeroText = styled(motion.h1)`
  color: var(--color-primary);
  cursor: default;

  &::after {
    content: "";
    margin-right: 10px;
  }
`;

export const HeroGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
`;

export const DesktopTextHolder = styled(motion.div)`
  grid-column: 2 / -1;
`;

export const OuterSpan = styled(motion.span)`
  cursor: default;

  display: block;
  clip-path: polygon(-100% 0, 200% 0, 200% 100%, -100% 100%);
`;

export const InnerSpan = styled(motion.span)`
  cursor: default;

  display: inline-block;

  &::after {
    content: "";
    margin-right: 20px;
  }

  @media ${QUERIES.phoneAndSmaller} {
    &::after {
      content: "";
      margin-right: 10px;
    }
  }
`;
